export default __webpack_public_path__ + "media/images/elephant-friend-a2039543a622b47c78d245539fd40670.png";